import { Route, Routes } from "react-router-dom";
import LiveMonitoring from "../module/LiveMonitoring/Component/liveMonitoring";
import Notifications from "../module/Notifications/Component/notification";
import AssetWiseList from "../module/LiveMonitoring/Component/assetWiseList";
import Dashboard from "../../BasicComponent/Components/underConstruction";

function AMSRoutes() {
  return (
    <Routes>
      <Route path="live-monitoring" element={<AssetWiseList />} />
      <Route path="live-monitoring/:uuid" element={<LiveMonitoring />} />
      {/* <Route path="notifications/*" element={<Notifications />} /> */}
      <Route path="notifications/*" element={<Dashboard />} />
    </Routes>
  );
}

export default AMSRoutes;
